var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero__bg"}),_c('img',{staticClass:"hero__img hero__img--top",attrs:{"src":_vm.heroTopImg,"alt":""}}),_c('img',{staticClass:"hero__img hero__img--bottom",attrs:{"src":_vm.heroBottomImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }